jQuery(document).ready(function($) {
    // Note: getPostIdFromBodyClass is now available globally from utilities.js

    // Download all: show spinner while zip is building, then trigger download
    $(document).on('click', '#downloadAllEvidenceBtn', function(e) {
        var $btn = $(this);
        var url = $btn.attr('data-download-url');
        if (!url || $btn.hasClass('disabled')) return;
        e.preventDefault();
        var $icon = $btn.find('.download-all-icon');
        var originalClass = $icon.attr('class');
        $icon.removeClass('fa-download').addClass('fa-spinner fa-spin');
        $btn.addClass('disabled').css('pointer-events', 'none');
        fetch(url, { credentials: 'same-origin' })
            .then(function(res) {
                if (!res.ok) throw new Error('Download failed');
                return res.blob();
            })
            .then(function(blob) {
                var a = document.createElement('a');
                a.href = URL.createObjectURL(blob);
                a.download = 'evidence-download.zip';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(a.href);
            })
            .catch(function() {
                alert('Download failed. Please try again.');
            })
            .finally(function() {
                $icon.attr('class', originalClass);
                $btn.removeClass('disabled').css('pointer-events', '');
            });
    });

    // Function to rename evidence
    window.renameEvidence = function(evidenceId) {
        var modal = $('#renameModal');
        modal.find('.btn-rename-confirm').attr('data-evidence-id', evidenceId);
        modal.modal('show');
    };

    // Function to confirm rename
    window.confirmRename = function() {
        var newName = $('input.renameEvidence').val();
        var evidenceId = $('#renameModal').find('.btn-rename-confirm').attr('data-evidence-id');
    
        if (newName != null && newName != "") {
            $.ajax({
                url: evidenceData.ajax_url,
                type: 'POST',
                data: {
                    action: 'rename_evidence',
                    evidenceId: evidenceId,
                    newName: newName,
                    nonce: evidenceData.nonce
                },
                success: function(response) {
                    if (response.success) {
                        location.reload();
                    } else {
                        alert("Error: " + response.data);
                    }
                }
            });
        }
    };

    // Function to delete evidence
    window.deleteEvidence = function(evidenceId) {
        var modal = $('#deleteConfirmModal');
        // Reset modal to confirmation state when opening
        $('#deleteLoadingContent').hide();
        $('#deleteConfirmContent').show();
        modal.find('.btn-delete-confirm').attr('data-evidence-id', evidenceId);
        modal.modal('show');
    };

    // Function to cancel modal
    window.cancelModal = function() {
        var modal = $('.modal');
        modal.modal('hide');
    };

    // Function to confirm delete
    window.confirmDelete = function() {
        var evidenceId = $('#deleteConfirmModal').find('.btn-delete-confirm').attr('data-evidence-id');
        
        // Show loading state
        $('#deleteConfirmContent').hide();
        $('#deleteLoadingContent').show();
    
        $.ajax({
            url: evidenceData.ajax_url,
            type: 'POST',
            data: {
                action: 'delete_evidence',
                evidenceId: evidenceId,
                nonce: evidenceData.nonce
            },
            success: function(response) {
                if (response.success) {
                    window.location.href = '/evidence';
                } else {
                    // Reset modal state and show error
                    $('#deleteLoadingContent').hide();
                    $('#deleteConfirmContent').show();
                    $('#deleteConfirmModal').modal('hide');
                    alert("Error: " + response.data);
                }
            },
            error: function(xhr, status, error) {
                // Reset modal state and show error
                $('#deleteLoadingContent').hide();
                $('#deleteConfirmContent').show();
                $('#deleteConfirmModal').modal('hide');
                alert("An error occurred while deleting the evidence. Please try again.");
            }
        });
    };

    // Function to edit evidence
    window.editEvidence = function(evidenceId) {
        console.log('Opening edit modal for evidence:', evidenceId);
        
        const $modal = $('#editEvidenceModal');
        
        // Reset expiration display on modal open
        $('#edit-expiration-display').show();
        $('#edit-expiration-form').hide();
        
        $modal.modal('show');
        
        // Show loading state and hide form content
        const $modalBody = $modal.find('.modal-body');
        const $form = $modalBody.find('#editEvidenceForm');
        
        // Hide the form and show loading state
        $form.hide();
        $modalBody.prepend('<div id="editLoadingState" class="text-center py-4"><div class="loader">' +
                          '<span class="loader_element"></span>' +
                          '<span class="loader_element"></span>' +
                          '<span class="loader_element"></span>' +
                          '</div></div>');
        
        // Load evidence data and assignment users
        $.ajax({
            url: evidenceData.ajax_url,
            type: 'POST',
            data: {
                action: 'get_evidence_data_for_edit',
                evidence_id: evidenceId,
                nonce: evidenceData.nonce
            },
            success: function(response) {
                if (response.success) {
                    // Load assignment users for the owner dropdown
                    loadAssignmentUsersForOwnerDropdown(evidenceId, function() {
                        setTimeout(function() {
                            $('#editLoadingState').remove();
                            $('#editEvidenceForm').show();
                            populateEditForm(response.data, evidenceId);
                        }, 1000);
                    });
                } else {
                    alert('Error loading evidence data: ' + (response.data.message || 'Unknown error'));
                    $modal.modal('hide');
                }
            },
            error: function(xhr, status, error) {
                alert('Error loading evidence data. Please try again.');
                $('#editLoadingState').remove();
                $('#editEvidenceForm').show();
                $modal.modal('hide');
            }
        });
    };

    // Function to check if current user is the evidence owner
    function checkEvidenceOwnership(evidenceSlug, callback) {
        console.log('Checking evidence ownership for:', evidenceSlug);
        
        $.ajax({
            url: evidenceData.ajax_url,
            type: 'POST',
            data: {
                action: 'check_evidence_ownership',
                evidence_id: evidenceSlug,
                nonce: evidenceData.nonce
            },
            success: function(response) {
                if (response.success) {
                    console.log('Evidence ownership check result:', response.data);
                    callback(response.data.is_owner);
                } else {
                    console.error('Failed to check evidence ownership:', response);
                    callback(false);
                }
            },
            error: function(xhr, status, error) {
                console.error('AJAX error checking evidence ownership:', error);
                callback(false);
            }
        });
    }

    // Function to load assignment users for the owner dropdown
    function loadAssignmentUsersForOwnerDropdown(evidenceId, callback) {
        console.log('Loading assignment users for owner dropdown, evidence ID:', evidenceId);
        
        // Get current user ID
        const currentUserId = evidenceData.current_user_id;
        
        if (!currentUserId) {
            console.error('No current user ID found');
            callback();
            return;
        }
        
        // Get AJAX URL and nonce
        const ajaxUrl = evidenceData.ajax_url;
        const nonce = evidenceData.nonce;
        
        if (!ajaxUrl || !nonce) {
            console.error('AJAX URL or nonce not found');
            callback();
            return;
        }
        
        // First get the actual evidence slug from the post ID (if needed)
        // For now, assume evidenceId is already the slug
        const evidenceSlug = evidenceId;
        
        $.ajax({
            url: ajaxUrl,
            type: 'POST',
            data: {
                action: 'get_assignment_users',
                user_id: currentUserId,
                evidence_id: evidenceSlug,
                nonce: nonce
            },
            success: function(response) {
                if (response.success && response.data) {
                    console.log('Assignment users loaded for owner dropdown:', response.data);
                    
                    // Populate the owner dropdown
                    const $ownerSelect = $('#editEvidenceOwner');
                    $ownerSelect.empty();
                    
                    response.data.forEach(function(user) {
                        const option = $('<option></option>')
                            .attr('value', String(user.id))
                            .text(user.name + ' (' + user.email + ')');
                        $ownerSelect.append(option);
                    });
                    
                    console.log('Owner dropdown populated with', response.data.length, 'users');
                    
                    // Check if current user is the owner and enable/disable field accordingly
                    checkEvidenceOwnership(evidenceSlug, function(isOwner) {
                        console.log('EDIT_EVIDENCE_DEBUG: Ownership check result:', isOwner);
                        if (isOwner) {
                            $ownerSelect.prop('disabled', false).prop('required', true);
                            $('#owner-permission-message').hide();
                            console.log('EDIT_EVIDENCE_DEBUG: Current user is evidence owner - owner field enabled');
                            console.log('EDIT_EVIDENCE_DEBUG: Owner field disabled state after enabling:', $ownerSelect.prop('disabled'));
                        } else {
                            $ownerSelect.prop('disabled', true).prop('required', false);
                            $('#owner-permission-message').show();
                            console.log('EDIT_EVIDENCE_DEBUG: Current user is not evidence owner - owner field disabled');
                            console.log('EDIT_EVIDENCE_DEBUG: Owner field disabled state after disabling:', $ownerSelect.prop('disabled'));
                        }
                    });
                } else {
                    console.error('Failed to load assignment users:', response);
                }
                callback();
            },
            error: function(xhr, status, error) {
                console.error('AJAX error loading assignment users:', error);
                callback();
            }
        });
    }

    // Function to populate the edit form with evidence data
    function populateEditForm(evidenceData, evidenceId) {
        $('#editEvidenceId').val(evidenceId);
        $('#editEvidenceName').val(evidenceData.post_title);
        $('#editEvidenceNotes').val(evidenceData.evidence_notes);
        
        initializeEditFormSelect2();
        
        setTimeout(function() {
            const $editEvidenceOwner = $('#editEvidenceOwner');
            const $editEvidenceDomain = $('#editEvidenceDomain');
            const $editEvidenceType = $('#editEvidenceType');
            const $editExpirationSchedule = $('#editExpirationSchedule');
            
            // Always set owner value to show current owner, even if field is disabled
            $editEvidenceOwner.val(String(evidenceData.evidence_owner || '')).trigger('change');
            
            if (evidenceData.evidence_domains && evidenceData.evidence_domains.length > 0) {
                const domainValues = evidenceData.evidence_domains.map(id => id.toString());
                $editEvidenceDomain.val(domainValues).trigger('change');
            } else {
                $editEvidenceDomain.val(null).trigger('change');
            }
            
            if (evidenceData.evidence_types && evidenceData.evidence_types.length > 0) {
                $editEvidenceType.val(evidenceData.evidence_types).trigger('change');
            } else {
                $editEvidenceType.val(null).trigger('change');
            }

            const expirationScheduleValue = evidenceData.expiration_schedule;
            $editExpirationSchedule.val(expirationScheduleValue).trigger('change');

            // Set the expiration date text
            const expirationDate = new Date(evidenceData.expiration_date + 'T00:00:00');
            const formattedDate = expirationDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
            $('#expiration-date-text').text(formattedDate);
            
            if (expirationScheduleValue === 'custom') {
                $('#editEvidenceModal .evidence-custom-expiration').show();
                $('#editCustomExpirationDate').val(evidenceData.expiration_date);
            } else {
                $('#editEvidenceModal .evidence-custom-expiration').hide();
            }
            $('#editEvidenceForm input[name="expirationDate"]').val(evidenceData.expiration_date);
            
            populateExistingFiles(evidenceData.files);
        }, 500);
    }

    // Function to populate existing files in the edit form
    function populateExistingFiles(files) {
        const $existingFilesList = $('.existing-files-list');
        $existingFilesList.empty();
        
        if (files && files.length > 0) {
            files.forEach(function(file) {
                const fileExtension = file.fileName.split('.').pop().toLowerCase();
                let iconClass = 'fa-file';
                
                switch (fileExtension) {
                    case 'pdf': iconClass = 'fa-file-pdf'; break;
                    case 'doc': case 'docx': iconClass = 'fa-file-word'; break;
                    case 'xls': case 'xlsx': iconClass = 'fa-file-excel'; break;
                    case 'jpg': case 'jpeg': case 'png': iconClass = 'fa-file-image'; break;
                    case 'mp4': iconClass = 'fa-file-video'; break;
                }
                
                const $fileItem = $(`
                    <div class="list-group-item">
                        <div class="d-flex justify-content-between align-items-center">
                            <div>
                                <i class="fas ${iconClass} me-2"></i>
                                ${file.fileName}
                            </div>
                            <span class="badge bg-secondary">Existing</span>
                        </div>
                    </div>
                `);
                
                $existingFilesList.append($fileItem);
            });
        } else {
            $existingFilesList.append('<p class="text-muted mb-0">No existing files</p>');
        }
    }

    // Function to initialize Select2 for edit form
    function initializeEditFormSelect2() {
        // Destroy existing Select2 instances first
        if ($('#editEvidenceDomain').data('select2')) {
            $('#editEvidenceDomain').select2('destroy');
        }
        if ($('#editEvidenceType').data('select2')) {
            $('#editEvidenceType').select2('destroy');
        }
        if ($('#editEvidenceOwner').data('select2')) {
            $('#editEvidenceOwner').select2('destroy');
        }
        if ($('#editExpirationSchedule').data('select2')) {
            $('#editExpirationSchedule').select2('destroy');
        }
        
            $('#editEvidenceDomain').select2({
                placeholder: "Select",
                width: '100%',
                dropdownParent: $('#editEvidenceModal'),
                allowClear: false,
                multiple: true
            });
        
            $('#editEvidenceType').select2({
                placeholder: "Select",
                width: '100%',
                dropdownParent: $('#editEvidenceModal'),
                allowClear: false,
                multiple: true
            });

            $('#editEvidenceOwner').select2({
                placeholder: "Select",
                width: '100%',
                dropdownParent: $('#editEvidenceModal'),
                allowClear: false,
                minimumResultsForSearch: Infinity
            });

            $('#editExpirationSchedule').select2({
                placeholder: "Select",
                width: '100%',
                dropdownParent: $('#editEvidenceModal'),
                allowClear: false,
                minimumResultsForSearch: Infinity
            });
    }

    // Handle edit evidence form submission
    $('#editEvidenceForm').on('submit', function(e) {
        e.preventDefault();
        var $form = $(this);
        var $submitButton = $form.find('button[type="submit"]');
        $submitButton.attr('disabled', 'disabled').text('Updating...');
        
        var formData = new FormData();
        formData.append('action', 'edit_evidence');
        formData.append('evidenceId', $('#editEvidenceId').val());
        formData.append('evidenceName', $('#editEvidenceName').val());
        formData.append('evidenceStatus', $('input[name="evidenceStatus"]').val());
        const evidenceDomainValues = $('#editEvidenceDomain').val();
        formData.append('evidenceDomain', JSON.stringify(evidenceDomainValues));
        const evidenceTypeValues = $('#editEvidenceType').val();
        formData.append('evidenceType', JSON.stringify(evidenceTypeValues));
        // Only include owner if the field is not disabled
        const $editEvidenceOwner = $('#editEvidenceOwner');
        console.log('EDIT_EVIDENCE_DEBUG: Owner field disabled:', $editEvidenceOwner.prop('disabled'));
        console.log('EDIT_EVIDENCE_DEBUG: Owner field value:', $editEvidenceOwner.val());
        if (!$editEvidenceOwner.prop('disabled')) {
            formData.append('evidenceOwner', $editEvidenceOwner.val());
            console.log('EDIT_EVIDENCE_DEBUG: Added evidenceOwner to form data:', $editEvidenceOwner.val());
        } else {
            console.log('EDIT_EVIDENCE_DEBUG: Owner field is disabled, not including in form data');
        }
        formData.append('expirationSchedule', $('#editExpirationSchedule').val());
        formData.append('expirationDate', $('input[name="expirationDate"]').val());
        formData.append('evidenceNotes', $('#editEvidenceNotes').val());
        formData.append('nonce', $('input[name="nonce"]').val());
        
        $.ajax({
            url: evidenceData.ajax_url,
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            success: function(response) {
                if (response.success) {
                    $('#editEvidenceModal').modal('hide');
                    location.reload();
                } else {
                    alert('Error: ' + (response.data.message || 'Unknown error occurred'));
                    $submitButton.removeAttr('disabled').text('Update Evidence');
                }
            },
            error: function(xhr, status, error) {
                alert('An error occurred while updating the evidence. Please check the console for details.');
                $submitButton.removeAttr('disabled').text('Update Evidence');
            }
        });
    });

    // Handle edit expiration schedule changes
    $('#editExpirationSchedule').on('change', function() {
        const selectedValue = $(this).val();
        
        if (selectedValue === 'custom') {
            const currentExpirationDate = $('input[name="expirationDate"]').val();
            $('#editCustomExpirationDate').val(currentExpirationDate);
            $('.evidence-custom-expiration').show();
        } else {
            $('.evidence-custom-expiration').hide();
            
            var days = parseInt(selectedValue);
            
            if (!isNaN(days) && days > 0) {
                var expirationDate = new Date();
                expirationDate.setDate(expirationDate.getDate() + days);
                var formattedDate = expirationDate.toISOString().split('T')[0];
                $('input[name="expirationDate"]').val(formattedDate);
            } else {
                $('input[name="expirationDate"]').val('');
            }
        }
    });

    // Handle edit custom expiration date changes
    $('#editCustomExpirationDate').on('blur', function() {
        const customDate = $(this).val();
        if (customDate) {
            $('input[name="expirationDate"]').val(customDate);
            const expirationDate = new Date(customDate + 'T00:00:00');
            const formattedDate = expirationDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
            $('#expiration-date-text').text(formattedDate);
            $('#edit-expiration-form').hide();
            $('#edit-expiration-display').show();
        }
    });

    // Handle pencil icon click to edit expiration date
    $('#edit-expiration-pencil').on('click', function() {
        $('#edit-expiration-display').hide();
        $('#edit-expiration-form').show();
    });

    // Track selected files across pagination
    var selectedFiles = {};

    // Initialize DataTables on evidence files table
    var evidenceFilesTable = null;
    if ($('#evidenceFilesTable').length && $.fn.DataTable) {
        evidenceFilesTable = $('#evidenceFilesTable').DataTable({
            order: [[1, 'asc']], // Sort by File Name (second column now) alphabetically
            pageLength: 25,
            searching: false,
            lengthChange: false,
            language: {
                info: "Showing _START_ to _END_ of _TOTAL_ files",
                infoEmpty: "No files available",
                emptyTable: "No files have been uploaded yet"
            },
            columnDefs: [
                {
                    targets: 0, // Checkbox column
                    orderable: false,
                    searchable: false
                },
                {
                    targets: 4, // Actions column (now index 4)
                    orderable: false,
                    searchable: false
                }
            ]
        });

        // Re-apply checkbox states after DataTable redraws (pagination, sorting)
        evidenceFilesTable.on('draw', function() {
            $('.file-checkbox').each(function() {
                var fileId = $(this).data('file-id');
                if (selectedFiles[fileId]) {
                    $(this).prop('checked', true);
                }
            });
            updateSelectAllCheckbox();
        });
    }

    // Function to update the selected files count and button visibility
    function updateSelectedFilesUI() {
        var checkedCount = Object.keys(selectedFiles).length;
        $('#selectedFilesCount').text(checkedCount);
        
        if (checkedCount > 0) {
            $('#deleteSelectedFiles').show();
        } else {
            $('#deleteSelectedFiles').hide();
        }
        
        updateSelectAllCheckbox();
    }

    // Function to update "select all" checkbox state for current page
    function updateSelectAllCheckbox() {
        var $visibleCheckboxes = $('.file-checkbox');
        var totalVisible = $visibleCheckboxes.length;
        var checkedVisible = $visibleCheckboxes.filter(':checked').length;
        
        if (totalVisible > 0 && checkedVisible === totalVisible) {
            $('#selectAllFiles').prop('checked', true);
            $('#selectAllFiles').prop('indeterminate', false);
        } else if (checkedVisible > 0 || Object.keys(selectedFiles).length > 0) {
            $('#selectAllFiles').prop('checked', false);
            $('#selectAllFiles').prop('indeterminate', true);
        } else {
            $('#selectAllFiles').prop('checked', false);
            $('#selectAllFiles').prop('indeterminate', false);
        }
    }

    // Handle individual file checkbox changes
    $(document).on('change', '.file-checkbox', function() {
        var fileId = $(this).data('file-id');
        var fileName = $(this).data('file-name');
        var evidenceId = $(this).data('evidence-id');
        
        if ($(this).prop('checked')) {
            // Add to selected files
            selectedFiles[fileId] = {
                fileId: fileId,
                fileName: fileName,
                evidenceId: evidenceId
            };
        } else {
            // Remove from selected files
            delete selectedFiles[fileId];
        }
        
        updateSelectedFilesUI();
    });

    // Handle "Select All" checkbox - selects ALL files across all pages
    $('#selectAllFiles').on('change', function() {
        var isChecked = $(this).prop('checked');
        
        if (evidenceFilesTable) {
            // Iterate through ALL rows in DataTable (all pages)
            evidenceFilesTable.rows().every(function() {
                var $row = $(this.node());
                var $checkbox = $row.find('.file-checkbox');
                
                if ($checkbox.length) {
                    var fileId = $checkbox.data('file-id');
                    var fileName = $checkbox.data('file-name');
                    var evidenceId = $checkbox.data('evidence-id');
                    
                    $checkbox.prop('checked', isChecked);
                    
                    if (isChecked) {
                        selectedFiles[fileId] = {
                            fileId: fileId,
                            fileName: fileName,
                            evidenceId: evidenceId
                        };
                    } else {
                        delete selectedFiles[fileId];
                    }
                }
            });
        } else {
            // Fallback for non-DataTable (shouldn't happen but just in case)
            $('.file-checkbox').each(function() {
                var fileId = $(this).data('file-id');
                var fileName = $(this).data('file-name');
                var evidenceId = $(this).data('evidence-id');
                
                $(this).prop('checked', isChecked);
                
                if (isChecked) {
                    selectedFiles[fileId] = {
                        fileId: fileId,
                        fileName: fileName,
                        evidenceId: evidenceId
                    };
                } else {
                    delete selectedFiles[fileId];
                }
            });
        }
        updateSelectedFilesUI();
    });

    // Handle bulk delete button click - show modal
    $('#deleteSelectedFiles').on('click', function() {
        var filesToDelete = Object.values(selectedFiles);

        if (filesToDelete.length === 0) {
            return;
        }

        // Populate the modal with file list
        var $fileList = $('#deleteFilesList');
        $fileList.empty();
        
        filesToDelete.forEach(function(file) {
            var fileExtension = file.fileName.split('.').pop().toLowerCase();
            var iconClass = 'fa-file';
            
            switch (fileExtension) {
                case 'pdf': iconClass = 'fa-file-pdf'; break;
                case 'doc': case 'docx': iconClass = 'fa-file-word'; break;
                case 'xls': case 'xlsx': iconClass = 'fa-file-excel'; break;
                case 'jpg': case 'jpeg': case 'png': iconClass = 'fa-file-image'; break;
                case 'mp4': iconClass = 'fa-file-video'; break;
            }
            
            $fileList.append(
                '<li class="mb-1"><i class="fas ' + iconClass + ' me-2 text-muted"></i>' + 
                $('<div>').text(file.fileName).html() + '</li>'
            );
        });
        
        $('#deleteFilesCount').text(filesToDelete.length);
        $('#deleteFilesTotalCount').text(filesToDelete.length);
        
        // Reset modal to confirmation state
        $('#deleteFilesConfirmContent').show();
        $('#deleteFilesLoadingContent').hide();
        
        // Show the modal
        $('#deleteFilesModal').modal('show');
    });

    // Handle confirm delete files button in modal
    $('#confirmDeleteFilesBtn').on('click', function() {
        var filesToDelete = Object.values(selectedFiles);

        if (filesToDelete.length === 0) {
            return;
        }

        // Show loading state in modal
        $('#deleteFilesConfirmContent').hide();
        $('#deleteFilesLoadingContent').show();
        $('#deleteFilesCurrentCount').text(0);
        $('#deleteFilesTotalCount').text(filesToDelete.length);

        var deletedCount = 0;
        var failedCount = 0;

        // Delete files sequentially to show progress
        function deleteNextFile(index) {
            if (index >= filesToDelete.length) {
                // All done
                if (failedCount > 0) {
                    alert(failedCount + ' file(s) could not be deleted. The page will refresh to show the current state.');
                }
                location.reload();
                return;
            }

            var file = filesToDelete[index];
            $('#deleteFilesCurrentCount').text(index + 1);

            $.ajax({
                url: evidenceData.ajax_url,
                type: 'POST',
                data: {
                    action: 'delete_evidence_file',
                    evidence_id: file.evidenceId,
                    file_id: file.fileId,
                    nonce: evidenceData.nonce
                },
                success: function(response) {
                    if (response.success) {
                        deletedCount++;
                    } else {
                        failedCount++;
                    }
                    deleteNextFile(index + 1);
                },
                error: function() {
                    failedCount++;
                    deleteNextFile(index + 1);
                }
            });
        }

        // Start deleting
        deleteNextFile(0);
    });

});
